export default function Attribute({ name, value }) {
  return (
    <p className="mb-0 text-break card-attribute">
      <b>{name}:</b> {value}
    </p>
  );
}
